import { render } from "./SwFilterDrawer.vue?vue&type=template&id=1b628dd1"
import script from "./SwFilterDrawer.vue?vue&type=script&lang=js"
export * from "./SwFilterDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__